<template>
  <section v-if="isLabExperienceUser" class="labs-experience-main">
    <template v-if="showSkillDive">
      <LabExperienceEnhanced />
    </template>
    <template v-else>
      <LabExperienceRegular />
    </template>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import LabExperienceEnhanced from '@/components/lab-experience/LabExperienceEnhanced.vue'
import LabExperienceRegular from '@/components/lab-experience/LabExperienceRegular.vue'

export default {
  name: 'LabsExperience',
  components: {
    LabExperienceEnhanced,
    LabExperienceRegular,
  },
  computed: {
    ...mapGetters({
      labExperienceCollection: 'featureFlags/labExperienceCollection',
      isSkillDiveB2CUser: 'auth/isSkillDiveB2CUser',
      isSkillDiveB2BUser: 'auth/isSkillDiveB2BUser',
      isLabExperienceLegacyB2BUser: 'auth/isLabExperienceLegacyB2BUser',
      labExperienceEnhance: 'featureFlags/labExperienceEnhance',
      isBusinessUser: 'business/isBusinessUser',
    }),
    isLabExperienceUser() {
      return (
        this.showLegacyLabExperience ||
        !this.isBusinessUser ||
        this.isSkillDiveB2BUser ||
        this.labExperienceEnhance
      )
    },
    showLegacyLabExperience() {
      return this.isLabExperienceLegacyB2BUser && !this.labExperienceEnhance
    },
    showSkillDive() {
      return (
        !this.isBusinessUser ||
        this.isSkillDiveB2BUser ||
        this.labExperienceEnhance
      )
    },
  },
  created() {
    if (!this.isLabExperienceUser) {
      this.$router.push({
        name: 'home',
      })
    }
  },
}
</script>
